module.exports = __webpack_public_path__ + "static/media/okcomply-bibliotheek.089cb295.png";